/* unplugin-vue-components disabled */import script from "./Popup.vue?vue&type=script&setup=true&lang=ts"
export * from "./Popup.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__